export enum ChartIconEnum {
    STAR = 'STAR',
    CHECK = 'CHECK',
    FIRE = 'FIRE',
    PAPER_PLANE = 'PAPER_PLANE',
    MEGAPHONE = 'MEGAPHONE',
    MAP_LOCATION = 'MAP_LOCATION',
    NEWSPAPER = 'NEWSPAPER',
    STORE = 'STORE',
    FLAG = 'FLAG',
    ROCKET = 'ROCKET',
    CROSSHAIRS = 'CROSSHAIRS',
    BULLSEYE_ARROW = 'BULLSEYE_ARROW',
    MONITOR_WAVEFORM = 'MONITOR_WAVEFORM',
    TROPHY_STAR = 'TROPHY_STAR',
    SACK_DOLLAR = 'SACK_DOLLAR',
    PARTY_HORN = 'PARTY_HORN',
    MESSAGE = 'MESSAGE',
    GAUGE_HIGH = 'GAUGE_HIGH',
    CHART_PIE = 'CHART_PIE',
    CHART_NETWORK = 'CHART_NETWORK',
    BOLT_LIGHTNING = 'BOLT_LIGHTNING'
};

export const chartIconToCoverageIconMap = new Map<ChartIconEnum, string>([
    [ChartIconEnum.STAR, 'fa-duotone fa-light fa-star'],
    [ChartIconEnum.CHECK, 'fa-duotone fa-light fa-check'],
    [ChartIconEnum.FIRE, 'fa-duotone fa-light fa-fire'],
    [ChartIconEnum.PAPER_PLANE, 'fa-duotone fa-light fa-paper-plane'],
    [ChartIconEnum.MEGAPHONE, 'fa-duotone fa-light fa-megaphone'],
    [ChartIconEnum.MAP_LOCATION, 'fa-duotone fa-light fa-map-location-dot'],
    [ChartIconEnum.NEWSPAPER, 'fa-duotone fa-light fa-newspaper'],
    [ChartIconEnum.STORE, 'fa-duotone fa-light fa-store'],
    [ChartIconEnum.FLAG, 'fa-duotone fa-light fa-flag'],
    [ChartIconEnum.ROCKET, 'fa-duotone fa-light fa-rocket-launch'],
    [ChartIconEnum.CROSSHAIRS, 'fa-duotone fa-light fa-crosshairs'],
    [ChartIconEnum.BULLSEYE_ARROW, 'fa-duotone fa-light fa-bullseye-arrow'],
    [ChartIconEnum.MONITOR_WAVEFORM, 'fa-duotone fa-light fa-monitor-waveform'],
    [ChartIconEnum.TROPHY_STAR, 'fa-duotone fa-light fa-trophy-star'],
    [ChartIconEnum.SACK_DOLLAR, 'fa-duotone fa-light fa-sack-dollar'],
    [ChartIconEnum.PARTY_HORN, 'fa-duotone fa-light fa-party-horn'],
    [ChartIconEnum.MESSAGE, 'fa-duotone fa-light fa-message'],
    [ChartIconEnum.GAUGE_HIGH, 'fa-duotone fa-light fa-gauge-high'],
    [ChartIconEnum.CHART_PIE, 'fa-duotone fa-light fa-chart-pie'],
    [ChartIconEnum.CHART_NETWORK, 'fa-duotone fa-light fa-chart-network'],
    [ChartIconEnum.BOLT_LIGHTNING, 'fa-duotone fa-light fa-bolt-lightning']
]);
